import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CalendarEventExceptionForm from '../containers/CalendarEventExceptionFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CalendarEventExceptionAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CalendarEventExceptionAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('calendar_event_exception_route_add')} />
          <CalendarEventExceptionForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CalendarEventExceptionAddScreen;

Logger.log('silly', `CalendarEventExceptionAddScreen loaded.`);
